import { DropdownError } from "app/core/components/alerts/DropdownError"
import { FC, useMemo } from "react"
import { Props as SelectProps } from "react-select"
import { DropdownSelect } from "../input/DropdownSelect"
import { useEnhancedField } from "./DisabledContext"
import { FieldLabel } from "./LabeledTextField"
import { SDropdownV3 } from "@superwall-me/sui"
import { FormErrorV2 } from "./LabeledTextFieldV2"

export interface LabeledDropdownSelectFieldProps extends SelectProps {
  /** Field name. */
  name: string
  /** Field label. */
  label: string
  creatable?: boolean
  onChange?: (value: any) => void
  overrideWrapperClassName?: string
  defaultValue?: SelectProps["value"]
  hideError?: boolean
  hideDropdownIndicator?: boolean
}

export const LabeledDropdownV2: FC<LabeledDropdownSelectFieldProps> = ({ ...allProps }) => {
  const {
    onChange: onChangeParent,
    name,
    label,
    options,
    defaultValue,
    overrideWrapperClassName,
    hideError = false,
    hideDropdownIndicator,
    ...props
  } = allProps
  const {
    input,
    meta: { touched, error, submitError, submitting },
    extra: { isDisabled },
    ...rest
  } = useEnhancedField(name)

  const normalizedError = Array.isArray(error) ? error.join(", ") : error || submitError
  const { onChange, value, ...restOfInput } = input

  const flattenedOptions = useMemo(() => {
    if (!options) {
      return undefined
    } else {
      return options.reduce((flattenedOptions, newOptions) => {
        if (newOptions.hasOwnProperty("value")) {
          return [...flattenedOptions, newOptions]
        } else {
          //@ts-ignore
          return [...flattenedOptions, ...newOptions.options]
        }
      }, [])
    }
  }, [options])

  return (
    <div className={overrideWrapperClassName ? overrideWrapperClassName : `relative mb-3`}>
      <FieldLabel htmlFor={name}>{label}</FieldLabel>
      <div className="relative mt-2">
        <SDropdownV3
          className="!h-[38px] !bg-transparent"
          aria-label={label}
          name={name}
          borderless={false}
          disabled={isDisabled}
          options={
            options?.map((o) => ({
              label: o.label,
              value: o.value,
            })) || []
          }
          onChange={(e) => {
            if (e) {
              onChange(e.value)
              onChangeParent ? onChangeParent(e.value) : ""
            }
          }}
          value={
            defaultValue
              ? flattenedOptions?.find((v) => v.value === value) || defaultValue
              : flattenedOptions?.find((v) => v.value === value)
          }
        />
        {touched && normalizedError && !hideError && (
          <FormErrorV2
            isDropdown
            hasLabel={label === "" ? false : true}
            normalizedError={normalizedError}
          />
        )}
      </div>
    </div>
  )
}
